<template>
  <van-tabbar
    v-if="show"
    v-model="active"
    active-color="#ff556e"
    inactive-color="#ff7186"
    :border="false"
    z-index="999"
    class="tabber_view"
  >
    <van-tabbar-item
      v-for="(item, index) in items"
      :key="index"
      replace
      :to="item.router"
    >
      <template #icon="props">
        <div class="tab-icon" :class="{ active: props.active }">
          <img
            :src="props.active ? item.icon.active : item.icon.noactive"
            :alt="item.title"
          />
        </div>
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      active: 0,
      items: [
        {
          router: '/Home',
          name: 'home',
          title: this.$t('common.homenav'),
          icon: {
            active: '/img/footer/home.png',
            noactive: '/img/footer/home_active.png',
          },
        },
        {
          router: '/Notice',
          name: 'Notice',
          title: this.$t('my.sys_notice'),
          icon: {
            active: '/img/footer/time.png',
            noactive: '/img/footer/time_active.png',
          },
        },
        {
          router: '/game_n',
          name: 'game_n',
          title: this.$t('game.nav') || '游戏',
          icon: {
            active: '/img/footer/like.png',
            noactive: '/img/footer/like_active.png',
          },
        },
        {
          router: '/Video',
          name: 'video',
          title: this.$t('video.title'),
          icon: {
            active: '/img/footer/video.png',
            noactive: '/img/footer/video_active.png',
          },
        },
        {
          router: '/Mine',
          name: 'mine',
          title: this.$t('common.minenav'),
          icon: {
            active: '/img/footer/mine.png',
            noactive: '/img/footer/mine_active.png',
          },
        },
      ],
    }
  },
  watch: {
    $route(to) {
      this.syncTab(to.name)
    },
  },
  created() {
    this.syncTab(this.$route.name)
  },
  methods: {
    syncTab(name) {
      const map = {
        home: 0,
        Notice: 1,
        MessageBoard: 1,
        game_n: 2,
        game: 2,
        choose: 2,
        list: 2,
        profile: 2,
        video: 3,
        PlayVideo: 3,
        mine: 4,
      }
      if (Object.prototype.hasOwnProperty.call(map, name)) {
        this.active = map[name]
        this.show = true
      } else {
        this.show = false
      }
    },
  },
}
</script>

<style lang="less" scoped>
.tabber_view {
  height: 14.667vw !important;
  background-color: #fff !important;
  box-shadow: 1.333vw 1.333vw 2.667vw #49507933;
}

/deep/ .van-tabbar-item__icon {
  margin-bottom: 0;
}

.tab-icon {
  background: #ffeef0;
  border-radius: 2.133vw;
  width: 11vw;
  height: 9vw;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    height: 5.333vw;
    display: block;
  }

  &.active {
    background: linear-gradient(90deg, #ff7186, #ff556e);
  }
}

/deep/ .van-tabbar-item--active {
  background-color: #fff !important;
}

[class*='van-hairline']::after {
  border: none !important;
}
</style>
